import React, { useState } from 'react';
import {
    Avatar,
    Text,
    Button,
    Paper,
    ActionIcon,
    createStyles,
    Modal,
    Group,
    Menu
} from '@mantine/core';
import {
    IconHelp,
    IconBook,
    IconSettings,
    IconLogout,
    IconMapPin,
    IconUser,
    IconFilter,
    IconCategory
} from '@tabler/icons';
import { HeaderSubSectionSelect } from './HeaderSubSectionSelect';
import { FilterCard } from './FilterCard';
import { AvatarOverlayCard } from './AvatarOverlayCard';

const useStyles = createStyles((theme) => ({
    topOfPage: {
        display: 'flex',
        justifyContent: 'space-evenly',
        position: 'fixed',
        backgroundColor: 'white',
        //marginTop: 120,
        borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
        top: 0,
        left: 0,
        height: '75px',
        width: '100%',
        
    },
    pageSections: {
        display: 'flex',
        justifyContent: 'center',
        position: 'fixed',
        top: '78px',
        left: 0,
        //height: '75px',
        width: '100%',
        
    },
    headerAreaWBorder: {
        width: '25%',
        height: '100%',
        borderRight: '1px ridge grey',
    },
    headerArea: {
        width: '25%',
        height: '100%',
    },
    menuItem: {
        width: '99%',
        height: '99%',
        justifyContent: 'center',
        pointerEvents: null,
    },

    links: {
        [theme.fn.smallerThan('xs')]: {
            marginTop: theme.spacing.md,
        },
    },
}));

export function MobileSimpleHeader({ avatar, drawSubSectMenu}) {
    const { classes } = useStyles();
    const [opened, setOpened] = useState(false);
    const [avatarOlayOpened, setAvatarOverlayOpened] = useState(false);
    
    
    //temporary to ensure we understand clicks then... set up the dispatch events
    function handleMenuClick(e) {
        console.log("menu area clicked");
        console.log(e.target.id);
        console.log(window.screen.width);
        console.log(window.screen.height);
        console.log("after width X height");
    }
    
    //<div id="headerD" className={classes.headerArea} onClick={handleMenuClick}>
    return (
        <>
            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Search Or Filter Results"
            >
                <FilterCard />
            </Modal>
            <Modal
                opened={avatarOlayOpened}
                onClose={() => setAvatarOverlayOpened(false)}
            >
                <AvatarOverlayCard />
            </Modal>
            <div className={classes.topOfPage}>
                <div id="headerA" className={classes.headerArea} onClick={() => setAvatarOverlayOpened(true)}>
                    <ActionIcon id="headerA" className={classes.menuItem}>
                        <Avatar src={avatar} size={50} radius={50} mx="auto" />
                    </ActionIcon>
                </div>
                <div id="headerB" className={classes.headerArea}>
                </div>
                <div id="headerC" className={classes.headerArea}>
                </div>
                <div id="headerD" className={classes.headerArea} onClick={() => setOpened(true)}>
                    <ActionIcon id="headerD" className={classes.menuItem}>
                        <IconCategory id="headerD" size={42} stroke={2.0}/>
                    </ActionIcon>
                </div>
            </div>
            <br/>
            {drawSubSectMenu &&
                <>
                    <div className={classes.pageSections}>
                        <HeaderSubSectionSelect />
                    </div>
                </>
            }
            
        </>
        

  );
}
